export default class ResetPasswordViewModel {
    public id: string = '';
    public password: string = '';
    public token: string = '';
}